import { render, staticRenderFns } from "./subdetailHeader.vue?vue&type=template&id=5f2183a2"
import script from "./subdetailHeader.vue?vue&type=script&lang=ts"
export * from "./subdetailHeader.vue?vue&type=script&lang=ts"
import style0 from "./subdetailHeader.vue?vue&type=style&index=0&id=5f2183a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports